import { RideHistoryPartialStoreState, RIDE_HISTORY_STATE_KEY } from './ride-history.reducer';

export const getRides = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].rides;

export const getLoading = (state: RideHistoryPartialStoreState) => state[RIDE_HISTORY_STATE_KEY].loading;

export const getStartDate = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].startDate;

export const getEndDate = (state: RideHistoryPartialStoreState) => state[RIDE_HISTORY_STATE_KEY].endDate;

export const getMaxStartDate = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].maxStartDate;

export const getMaxEndDate = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].maxEndDate;

export const getMinStartDate = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].minStartDate;

export const getMinEndDate = (state: RideHistoryPartialStoreState) =>
    state[RIDE_HISTORY_STATE_KEY].minEndDate;

export const getDateDiff = (state: RideHistoryPartialStoreState) => state[RIDE_HISTORY_STATE_KEY].diff;
